import { heroStats, hotTopics } from '@/mocks/communityData';
import SectionHeading from './SectionHeading';

export default function StatsTopics() {
  return (
    <section id="topics" className="border-y border-background-200/60 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-200/70 bg-background-50 px-4 py-5 text-center"
            >
              <p className="font-heading text-2xl font-bold text-accent-600 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="此刻在聊"
            title="热门话题榜，总有一款想参与"
            desc="看看大家最近都在聊什么料，点进感兴趣的话题，随时加入一场真实的互动讨论。"
          />
          <a
            href="#categories"
            className="whitespace-nowrap self-start rounded-md border border-accent-300 bg-background-50 px-4 py-2 text-sm font-medium text-accent-700 hover:bg-accent-100 transition-colors cursor-pointer"
          >
            换个分类逛一逛
          </a>
        </div>

        <ul className="mt-6 flex flex-wrap gap-3">
          {hotTopics.map((t) => (
            <li key={t.title}>
              <a
                href="#topics"
                onClick={(e) => e.preventDefault()}
                className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/80 bg-background-50 px-4 py-2 text-sm text-foreground-800 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <span className="text-foreground-800 group-hover:text-primary-700">{t.title}</span>
                <span className="text-xs text-foreground-400">{t.count}</span>
                <i className="ri-arrow-right-up-line text-primary-500"></i>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}